import { call, put } from "redux-saga/effects";
import messages from "../../assets/locale/messages";
import * as apis from "../../network/apis/programs";
import { showHideSnackbar } from "../Snackbar/actions";
import {
  addProgramResponse,
  addProgramsResponse,
  addUsersInsideProgramResponse,
  editProgramResponse,
  getProgramRequest,
  getProgramsRequest,
  getUsersInsideProgramRequest
} from "./actions";

export function* getProgramsSaga({ payload }) {
  try {
    const response = yield call(apis.getPrograms, payload);
    yield put(
      addProgramsResponse({
        programs: response.data.data.programs,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"]
        }
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* getProgramSaga({ payload }) {
  try {
    const response = yield call(apis.getProgram, payload);
    yield put(addProgramResponse(response.data.program));
  } catch (err) {
    console.error(err);
  }
}

export function* getUsersProgramSaga({ payload }) {
  try {
    const response = yield call(apis.getUsersInsideProgram, payload);
    yield put(
      addUsersInsideProgramResponse({
        users: response.data.data.users,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"]
        }
      })
    );

    yield put(addProgramResponse(response.data.program));
  } catch (err) {
    console.error(err);
  }
}

export function* deleteProgramSaga({ payload }) {
  try {
    const { id, page } = payload;
    const response = yield call(apis.deletePrograms, id);

    yield put(
      getProgramsRequest({
        items: 10,
        page
      })
    );

    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message: messages[response.lang].programs.deleteProgramSuccess
      })
    );
  } catch (err) {
    console.error(err);
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "error",
        message: "Delete failed"
      })
    );
  }
}

export function* addProgramSaga({ payload }) {
  try {
    const { program, page } = payload;
    const response = yield call(apis.createPrograms, program);
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message: messages[response.lang].programs.addProgramSuccess
      })
    );
    yield put(getProgramsRequest({ items: 10, page }));
  } catch (err) {
    console.error(err);
  }
}

export function* assignDirectorToProgramSaga({ payload }) {
  try {
    console.log("payload", payload);
    const response = yield call(
      apis.assignDirectorsToProgram,
      payload
    );
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].programs.assignDirectorSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* assignUsersFromFileToProgramSaga({ payload }) {
  try {
    const response = yield call(
      apis.assignUsersFromFileToProgram,
      payload
    );
    yield put(
      getUsersInsideProgramRequest({
        id: payload?.id,
        page: 1,
        items: 10
      })
    );

    yield put(getProgramRequest(payload.id));

    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message: messages[response.lang].programs.assignUsersSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}
export function* assignBooksToProgramSaga({ payload }) {
  try {
    const response = yield call(apis.assignBooksToProgram, payload);
    yield put(getProgramRequest(payload.id));
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message: messages[response.lang].programs.assignBooksSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}
export function* deleteUserFromProgramSaga({ payload }) {
  try {
    const response = yield call(apis.deleteUserFromProgram, payload);

    yield put(
      getUsersInsideProgramRequest({
        id: payload?.id,
        page: 1,
        items: 10
      })
    );
    yield put(getProgramRequest(payload.id));
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message: messages[response.lang].programs.removeUserSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* editProgramSaga({ payload }) {
  try {
    const response = yield call(apis.editProgram, payload);
    yield put(editProgramResponse(response.data.program));
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message: messages[response.lang].programs.programUpdateSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}
